<template>
  <div>
    <div
      v-for="ticket in filteredTicketTypes"
      :key="ticket.id"
      class="px-2 md:px-0"
    >
      <ticket-card
        :ticket="ticket"
        :can-opent-ticket="false"
        class="cursor-pointer"
        :class="
          selectedTickets.includes(ticket.id)
            ? 'selected-ticket'
            : 'not-selected-ticket'
        "
        @click="selectTicket(ticket)"
      />
    </div>
    <div class="flex justify-center mt-8 space-x-8">
      <wegow-button
        v-if="selectedTickets.length"
        background="opacity"
        :text="$t('wegow.purchase.savePreferences')"
        color="topaz"
        @click="$emit('accept', selectedTickets)"
      />
      <wegow-button
        :text="$t('general.cancel')"
        color="white"
        border="topaz"
        @click="$emit('cancel')"
      />
    </div>
  </div>
</template>

<script setup>
import { usePurchase } from "@/composables/usePurchase";

import WegowButton from "@/components/general/forms/WegowButton";
import TicketCard from "@/components/wegow/purchase/TicketCard";
import { computed, onMounted, ref } from "vue";

const { actualPurchase } = usePurchase();

defineEmits("accept", "cancel");

const selectedTickets = ref([]);

const filteredTicketTypes = computed(() => {
  return actualPurchase.value.selectedTickets?.filter(
    ticket => !ticket.available && !ticket.reserved
  );
});
const selectTicket = ticket => {
  let index = selectedTickets.value.findIndex(
    selectedTicket => selectedTicket === ticket.id
  );
  if (index === -1) {
    selectedTickets.value.push(ticket.id);
  } else {
    selectedTickets.value.splice(index, 1);
  }
};
onMounted(() => {
  selectedTickets.value.push(filteredTicketTypes.value[0].id);
});
</script>

<style lang="scss" setup>
.selected-ticket {
  border: 1px solid $topaz;
}
.not-selected-ticket {
  opacity: 0.5;
}
</style>
